export const environment = {
  state: 'production',
  baseUrl: 'https://malirang.com',
  kakao: {
    redirectUri: 'https://teacher.malirang.com/login/kakao',
    clientId: '17fb497a6372cba8f4f3e59726381836',
    appKey: '6889d1d6aed5dbb723d85b0bbec1f96d',
  },
  naver: {
    redirectUri: 'https://teacher.malirang.com/login/naver',
    clientId: 'y0hF29XTrPxqx53QjUY1',
    clientSecret: 'SW3_y0Z9UK',
  },
  firebase: {
    apiKey: 'AIzaSyDudw6SODQ3odVjLmHYMDroaPFtXeHYtds',
    authDomain: 'malirang-95d03.firebaseapp.com',
    projectId: 'malirang-95d03',
    storageBucket: 'malirang-95d03.firebasestorage.app',
    messagingSenderId: '317709108989',
    appId: '1:317709108989:web:472bf0a3e3ff33e9b5e094',
    measurementId: 'G-RCMM2WNFHL',
  },
  nhn: {
    objectStorageContainer: 'test',
  },
  landing: {
    url: 'https://teacher.malirang.com',
  },
  toss: {
    widgetClientKey: 'test_gck_docs_Ovk5rk1EwkEbP0W43n07xlzm',
  },
};
